/**
 * Extracted from `components/product-home/product-shelf-illustration.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

export function shelfCardField(brandColor: string): string {
  return `color-mix(in oklch, ${brandColor} 10%, var(--card))`
}
